/**
 * This does below things:
 * Adds href (for all-goals page) to all anchor tags for mentions in the htmlString
 * Adds target=_blank to other anchor tags
 * @param htmlString
 * @param orgId
 * @returns {string}
 */
export default (htmlString, orgId) => {
  const div = document.createElement('div')
  div.innerHTML = htmlString
  div.setAttribute('class', 'wysiwyg-content')
  // update Anchors
  div.querySelectorAll('a').forEach(anchor => {
    if (anchor.classList.contains('mention')) {
      const { userId } = anchor.dataset
      anchor.setAttribute('href', `/orgs/${orgId}/users/${userId}`)
    } else {
      anchor.setAttribute('target', '_blank')
      anchor.setAttribute('rel', 'nofollow noopener noreferrer')
    }
  })
  // lazy load images
  div.querySelectorAll('img').forEach(img => {
    img.setAttribute('loading', 'lazy')
  })
  return div.outerHTML
}
